/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { ChromePicker } from "react-color";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import Card from "../../../../../components/Cards/Card";
import { getDomainBrandIdentity } from "../../../../../store/actions/domain-brand.action";
import { fetchAppLanguage } from "../../../../../utils/helpers/logicHelper";
import { fetchSubDomain } from "../../../../../utils/services/baseUrl";
import { ManagerService } from "../../../../../utils/services/manager.service";

function Color({ dictionary, domainBrand }) {
  const dispatch = useDispatch();
  const subdomain = fetchSubDomain();
  const selectedLanguage = fetchAppLanguage();
  const [open] = useState(false);
  const [color, setColor] = useState(false);
  const [loading, setLoading] = useState(false);
  const [colorPallet, setColorPallet] = useState({
    buttonColor: domainBrand?.domainBrand?.buttonColor || "#000",
    button_text_color: domainBrand?.domainBrand?.button_text_color || "#000",
    buttonActive1: domainBrand?.domainBrand?.buttonActive1 || "#000",
    buttonHoverColor: domainBrand?.domainBrand?.buttonHoverColor || "#000",
    buttonColor1: domainBrand?.domainBrand?.buttonColor1 || "#000",
    buttonTextColor1: domainBrand?.domainBrand?.buttonTextColor1 || "#000",
    buttonActive2: domainBrand?.domainBrand?.buttonActive2 || "#000",
    buttonHoverColor1: domainBrand?.domainBrand?.buttonHoverColor1 || "#000",
    buttonColor2: domainBrand?.domainBrand?.buttonColor2 || "#000",
    buttonTextColor2: domainBrand?.domainBrand?.buttonTextColor2 || "#000",
    buttonActive3: domainBrand?.domainBrand?.buttonActive3 || "#000",
    buttonHoverColor2: domainBrand?.domainBrand?.buttonHoverColor2 || "#000",
    backgroundColor: domainBrand?.domainBrand?.backgroundColor || "#000",
    top_bottom_bar: domainBrand?.domainBrand?.top_bottom_bar || "#000",
    font_style1: domainBrand?.domainBrand?.font_style1 || "#000",
    text_color: domainBrand?.domainBrand?.text_color || "#000",
    font_style6: domainBrand?.domainBrand?.font_style6 || "#000",
    page_title_color: domainBrand?.domainBrand?.page_title_color || "#000",
    link_color: domainBrand?.domainBrand?.link_color || "#000",
    font_style2: domainBrand?.domainBrand?.font_style2 || "#000",
    font_style3: domainBrand?.domainBrand?.font_style3 || "#000",
  });

  const updateBrandSettings = async (payload) => {
    setLoading(true);
    try {
      const response = await ManagerService.updateBrandSettings(payload);
      if (response.status === 200) {
        toast.success(response.data.message);
        dispatch(getDomainBrandIdentity(subdomain, selectedLanguage["id"]));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  return (
    <>
      <Card>
        <ul className="list-group">
          <li
            className="list-group-item collapse-text text-uppercase fw-bold"
            onClick={() => setColor(!color)}
            aria-controls="example-collapse-text"
            aria-expanded={open}
            style={{ cursor: "pointer", borderBottom: "0px solid" }}
          >
            {color ? (
              <i className="fa fa-minus" aria-hidden="true" />
            ) : (
              <i className="fa fa-plus" aria-hidden="true" />
            )}{" "}
            &nbsp;
            {dictionary ? dictionary["l_color_settings"] : "COLOR SETTINGS"}
          </li>
          <Collapse in={color}>
            <div id="example-collapse-text" className="px-3">
              <h6 className="fw-bold">
                {dictionary
                  ? dictionary[
                      "para_set_primary,_secondary,_background_color..."
                    ]
                  : `Set primary, secondary, background color etc. of your choice here.`}
              </h6>

              {/* submit */}
              <h6 className="fw-bold mx-auto text-uppercase pt-4 text-center mt-5">
                {dictionary ? dictionary["l_submit_button"] : `SUBMIT BUTTON`}
              </h6>
              <hr />
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["l_submit_button"]} - ${dictionary["l_background"]}`
                      : `Submit Button - Background`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.buttonColor}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        buttonColor: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["l_submit_button"]} - ${dictionary["para_text_color"]}`
                      : `Submit Button - Text Color`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.button_text_color}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        button_text_color: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {/* {dictionary
                              ? `${dictionary["l_submit_button"]} - ${dictionary["para_text_color"]}`
                              : `Submit Button - :focus and :active`} */}
                    Submit Button - :focus and :active
                  </h6>

                  <ChromePicker
                    color={colorPallet?.buttonActive1}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        buttonActive1: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["l_submit_button"]} - ${dictionary["l_hover_color"]}`
                      : `Submit Button - Hover Color`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.buttonHoverColor}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        buttonHoverColor: color?.hex,
                      });
                    }}
                  />
                </div>
              </div>

              {/* regular */}
              <h6 className="fw-bold mx-auto text-uppercase pt-4 mx-auto text-center mt-4">
                {dictionary ? dictionary["l_regular_button"] : `REGULAR BUTTON`}
              </h6>
              <hr />
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["l_regular_button"]} - ${dictionary["l_background"]}`
                      : `Regular Button - Background`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.buttonColor1}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        buttonColor1: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["l_regular_button"]} - ${dictionary["para_text_color"]}`
                      : `Regular Button - Text Color`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.buttonTextColor1}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        buttonTextColor1: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {/* {dictionary
                              ? `${dictionary["l_submit_button"]} - ${dictionary["para_text_color"]}`
                              : `Submit Button - :focus and :active`} */}
                    Regular Button - :focus and :active
                  </h6>

                  <ChromePicker
                    color={colorPallet?.buttonActive2}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        buttonActive2: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["l_regular_button"]} - ${dictionary["l_hover_color"]}`
                      : `Regular Button - Hover Color`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.buttonHoverColor1}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        buttonHoverColor1: color?.hex,
                      });
                    }}
                  />
                </div>
              </div>

              {/* delete */}
              <h6 className="fw-bold mx-auto text-uppercase pt-4 mx-auto text-center">
                {dictionary ? dictionary["l_delete_button"] : `DELETE BUTTON`}
              </h6>
              <hr />
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["l_delete_button"]} - ${dictionary["l_background"]}`
                      : `Delete Button - Background`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.buttonColor2}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        buttonColor2: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["l_delete_button"]} - ${dictionary["para_text_color"]}`
                      : `Delete Button - Text Color`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.buttonTextColor2}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        buttonTextColor2: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {/* {dictionary
                              ? `${dictionary["l_submit_button"]} - ${dictionary["para_text_color"]}`
                              : `Submit Button - :focus and :active`} */}
                    Delete Button - :focus and :active
                  </h6>

                  <ChromePicker
                    color={colorPallet?.buttonActive3}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        buttonActive3: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["l_delete_button"]} - ${dictionary["l_hover_color"]}`
                      : `Delete Button - Hover Color`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.buttonHoverColor2}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        buttonHoverColor2: color?.hex,
                      });
                    }}
                  />
                </div>
              </div>

              <h6 className="fw-bold mx-auto text-uppercase pt-4 mx-auto text-center">
                {dictionary ? dictionary["WO_OTHER_-1676076012"] : `OTHERS`}
              </h6>
              <hr />
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["para_background_color"]}`
                      : `Background Color`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.backgroundColor}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        backgroundColor: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["para_top_and_bottom_bar_color"]}`
                      : `Top and bottom bar color`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.top_bottom_bar}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        top_bottom_bar: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["l_nav_links"]}`
                      : `Navigation Links`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.font_style1}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        font_style1: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["l_nav_links_hover"]}`
                      : `Navigation Links Hover`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.font_style6}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        font_style6: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["para_text_color"]}`
                      : `Text Color`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.text_color}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        text_color: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["para_page_title_color"]}`
                      : `Page Title Color`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.page_title_color}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        page_title_color: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["para_links_color"]}`
                      : `Links Color`}
                  </h6>

                  <ChromePicker
                    color={
                      colorPallet?.link_color !== null
                        ? colorPallet?.link_color
                        : ""
                    }
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        link_color: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary
                      ? `${dictionary["l_support_link"]}`
                      : `Support Links`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.font_style2}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        font_style2: color?.hex,
                      });
                    }}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <h6 className="fw-bold text-uppercase pt-4">
                    {dictionary ? `${dictionary["l_labels"]}` : `Labels`}
                  </h6>

                  <ChromePicker
                    color={colorPallet?.font_style3}
                    onChange={(color) => {
                      setColorPallet({
                        ...colorPallet,
                        font_style3: color?.hex,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 float-start mb-3">
                  <button
                    // onClick={() => updateRemittanceValue(hideObject)}
                    className="login100-form-btn btn-primary fw-bold text-uppercase"
                    type={"button"}
                  >
                    {dictionary
                      ? dictionary["l_reset_settings"]
                      : "RESET SETTINGS"}

                    {/* {loading && (
                      <>
                        <i className="fa fa-spinner fa-spin" />
                      </>
                    )} */}
                  </button>
                </div>
                <div className="col-lg-6 col-md-6 float-end mb-3">
                  <button
                    onClick={() => updateBrandSettings(colorPallet)}
                    className="login100-form-btn btn-primary fw-bold text-uppercase"
                    type={"button"}
                  >
                    {dictionary
                      ? dictionary["b_update_colors"]
                      : "UPDATE COLORS"}
                    &nbsp;&nbsp;
                    {loading && (
                      <>
                        <i className="fa fa-spinner fa-spin" />
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </ul>
      </Card>
    </>
  );
}

export default Color;
